
import { Component, Vue, Watch } from 'vue-property-decorator'
import { apiServiceGet, apiServiceSet } from '@/api/setting'
import materialSelect from '@/components/material-select/index.vue'

@Component({
  components: {
    materialSelect
  }
})
export default class ListsDetail extends Vue {
  /** S Data **/

  // เพิ่มข้อมูลแบบฟอร์มร้านค้า
  form: any = {
    service_name: '', // ชื่อบริการลูกค้า
    service_mobile: '', // หมายเลขโทรศัพท์ฝ่ายบริการลูกค้า
    service_qrcode: '' // รหัส QR
  };

  // การตรวจสอบแบบฟอร์ม
  rules = {
    service_name: [{ required: true, message: 'กรุณากรอกชื่อฝ่ายบริการลูกค้า', trigger: 'blur' }],
    service_mobile: [{ required: true, message: 'กรุณากรอกหมายเลขโทรศัพท์ฝ่ายบริการลูกค้า', trigger: 'blur' }],
    service_qrcode: [
      { required: true, message: 'กรุณาเลือกรหัส QR ฝ่ายบริการลูกค้า', trigger: 'blur' }
    ]
  };

  /** E Data **/

  /** S Methods **/
  // คลิกเพื่อส่งแบบฟอร์ม
  onSubmit (formName: string) {
    // ตรวจสอบว่ารูปแบบแบบฟอร์มถูกต้อง
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return
      this.handleEdit()
    })
  }

  async handleEdit () {
    await apiServiceSet({ ...this.form })
    this.getShopDetailFunc()
  }

  // รับรายละเอียด
  async getShopDetailFunc (): Promise<void> {
    const res: any = await apiServiceGet()
    Object.keys(res).map((key) => {
      this.$set(this.form, key, res[key])
    })
  }
  /** E Methods **/

  /** S Life Cycle **/
  created () {
    this.getShopDetailFunc()
  }
  /** E Life Cycle **/
}
